import { render, staticRenderFns } from "./GeneralTabs.vue?vue&type=template&id=c72d2ab0&"
import script from "./GeneralTabs.vue?vue&type=script&lang=js&"
export * from "./GeneralTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports